import React from "react";

import dayjs from "dayjs";

import { Tag } from "clearsense-ui/components";
import { Steward, LinkText } from "components/Common/TableStyle";

const DATA_SOURCE_COLUMNS = cde => [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: 200,
    fixed: "left",
    render: (text, record) => (
      <LinkText
        text={text}
        link={`/management/data-sources/${record.id}/cde/${cde.id}/dsde`}
      />
    ),
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: 400,
  },
  {
    title: "Type",
    key: "type",
    dataIndex: "type",
    width: 200,
    render: () => "RDBMS",
  },
  {
    title: "DS Status",
    key: "status",
    dataIndex: "status",
    width: 200,
    render: (text, record) => (
      <Tag
        label={record?.unmapped_count === 0 ? "Ingested" : "Profiled"}
        color={record?.unmapped_count === 0 ? "#ebf5ec" : "#FDF0E3"}
      />
    ),
  },
  {
    title: "# Data Source Data Element",
    key: "dsdes_count",
    dataIndex: "dsdes_count",
    width: 150,
  },
  {
    title: "# Incomplete Mapping",
    key: "unmapped_count",
    dataIndex: "unmapped_count",
    width: 150,
  },
  {
    title: "Drafter",
    key: "drafter",
    dataIndex: "drafter",
    width: 200,
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    title: "Approver",
    key: "approver",
    dataIndex: "approver",
    width: 200,
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    title: "Last Updated",
    key: "updated_at",
    dataIndex: "updated_at",
    width: 200,
    render: text => dayjs(text).format("MM/DD/YYYY"),
  },
];

export { DATA_SOURCE_COLUMNS };
